module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'priceConfigs',
        preventClearOnCancel: true,
    },

    methods: {

        dataDealer(){
            this.model.namedFields.valid.config = this.model.namedFields.valid.config || {}
            this.model.namedFields.valid.config.disabled = true
        },
    },
}